import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Ticket from './icon-ticket.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Ticket {...validProps} />;
}
SvgComponent.iconName = 'ticket';

/**
 * @deprecated This is a legacy icon
 */
export const TicketIcon = svgIconWrapper(SvgComponent);
